var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrinterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.45312 8.16732H19.5365V5.83398C19.5365 3.50065 18.6615 2.33398 16.0365 2.33398H11.9531C9.32812 2.33398 8.45312 3.50065 8.45312 5.83398V8.16732Z",
    stroke: "#1E4387",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6615 17.5V22.1667C18.6615 24.5 17.4948 25.6667 15.1615 25.6667H12.8281C10.4948 25.6667 9.32812 24.5 9.32812 22.1667V17.5H18.6615Z",
    stroke: "#1E4387",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 11.667V17.5003C24.5 19.8337 23.3333 21.0003 21 21.0003H18.6667V17.5003H9.33333V21.0003H7C4.66667 21.0003 3.5 19.8337 3.5 17.5003V11.667C3.5 9.33366 4.66667 8.16699 7 8.16699H21C23.3333 8.16699 24.5 9.33366 24.5 11.667Z",
    stroke: "#1E4387",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8385 17.5H18.4269H8.17188",
    stroke: "#1E4387",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.17188 12.834H11.6719",
    stroke: "#1E4387",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinterIcon);
export default __webpack_public_path__ + "static/media/printer-icon.14cd525345d55683568d1fd02929f6ed.svg";
export { ForwardRef as ReactComponent };